import { useState, useEffect } from 'react';
import { getProfileImage } from '../lib/api/file';

/**
 * 프로필 이미지를 axios를 통해 로드하는 커스텀 훅
 * 인증 토큰을 포함하여 이미지를 가져오고 Blob URL로 변환
 * 
 * @param {string} usrUuid - 사용자 UUID
 * @param {string} profileImg - 프로필 이미지 URL (있는지 확인용)
 * @returns {string|null} Blob URL 또는 null
 */
const useProfileImage = (usrUuid, profileImg) => {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    let objectUrl = null;

    const loadImage = async () => {
      if (!usrUuid || !profileImg) {
        setImageUrl(null);
        return;
      }

      try {
        const response = await getProfileImage(usrUuid, profileImg);
        objectUrl = URL.createObjectURL(response.data);
        setImageUrl(objectUrl);
      } catch (error) {
        // 404(이미지가 저장소에 없음)는 기본 아바타로 조용히 대체한다 - 예상되는 상황이라
        // 콘솔에 에러를 남기지 않는다. 그 외(네트워크/서버 오류)는 그대로 로그를 남긴다.
        if (error?.response?.status !== 404) {
          console.error('Failed to load profile image:', error);
        }
        setImageUrl(null);
      }
    };

    loadImage();

    // Cleanup: Blob URL 해제
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [usrUuid, profileImg]);

  return imageUrl;
};

export default useProfileImage;
